import { lenis } from '../utilities/lenis';

// CONTENT LIBRARY LIGHTBOX
document.addEventListener('DOMContentLoaded', function() {
  const contentLibraryThumbnails = document.querySelectorAll('.c-content-library_block');
  if(contentLibraryThumbnails.length > 0){
    const contentLibraryLightbox = document.querySelector('.c-content-library_lightbox');
    contentLibraryThumbnails.forEach(contentLibraryThumbnail => {
      contentLibraryThumbnail.addEventListener('click', function() {
        gsap.set(contentLibraryLightbox, {display: 'flex'});

        const contentLibraryImage = contentLibraryLightbox.querySelector('.c-content-library_lightbox img');
        const contentLibraryText = contentLibraryLightbox.querySelector('.c-text-bubble');

        // empty image
        gsap.set(contentLibraryImage, {display: 'none'});
        contentLibraryImage.src = '';
        contentLibraryImage.alt = '';

        // empty text
        gsap.set(contentLibraryText, {display: 'none'});
        contentLibraryText.innerHTML = '';

        if(contentLibraryThumbnail.querySelector('img') !== null){
          // Check if the thumbnail has an image or text
          const imageSrc = contentLibraryThumbnail.querySelector('img').src;
          const imageAlt = contentLibraryThumbnail.querySelector('img').alt;

          // Set the image source
          contentLibraryLightbox.querySelector('.c-content-library_lightbox img').src = imageSrc;
          contentLibraryLightbox.querySelector('.c-content-library_lightbox img').alt = imageAlt;

          // Show the image
          gsap.set(contentLibraryImage, {display: 'block'});
        } else{
          // Set the text
          const textElement = contentLibraryThumbnail.querySelector('.c-text-bubble').innerHTML;
          contentLibraryLightbox.querySelector('.c-text-bubble').innerHTML = textElement;

          // Show the text
          gsap.set(contentLibraryText, {display: 'block'});
        }

        // scroll .c-lightbox-inner back to top
        contentLibraryLightbox.querySelector('.c-lightbox-inner').scrollTop = 0;


        lenis.stop();
      });
    });

    contentLibraryLightbox.addEventListener('click', function(e) {
      if(e.target.classList.contains('c-content-library_lightbox')){
        gsap.set(contentLibraryLightbox, {display: 'none'});
        lenis.start();
      }
    });
  }
});